import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Spacer,
} from "@chakra-ui/react";
import React from "react";
import { Link, useLocation } from "react-router-dom";

const Furniture = () => {
  let location = useLocation();
  let routes = location.pathname.substring(1).split("/");
  console.log(location.pathname.substring(1).split("/"));
  return (
    <Box>
      <Flex>
        <Breadcrumb>
          {routes.map((route, i) => (
            <BreadcrumbItem>
              <Link to={`/${route}`}>{
                i === 0 ? "Home" : `${route}`
              }</Link>
            </BreadcrumbItem>
          ))}
          {/* <BreadcrumbItem>
            <Link to={"/"}>Home</Link>
          </BreadcrumbItem>

          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink href="#">Docs</BreadcrumbLink>
          </BreadcrumbItem>

          <BreadcrumbItem>
            <BreadcrumbLink href="#">Breadcrumb</BreadcrumbLink>
          </BreadcrumbItem> */}
        </Breadcrumb>
        <Spacer />
        <Flex>
          <Box>Packages</Box>
          <Box>Furniture</Box>
          <Box>Appliances</Box>
          <Box>Electronics</Box>
          <Box>Fitness</Box>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Furniture;
